import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { ModuleRegistry, AllCommunityModule, ClientSideRowModelModule } from 'ag-grid-community';
import {
    RowGroupingModule,
    RowGroupingPanelModule,
    LicenseManager,
    MenuModule,
    ExcelExportModule,
    ClipboardModule,
} from 'ag-grid-enterprise';
import { Amplify } from 'aws-amplify';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

// Set AG Grid Enterprise license key once for the entire application
LicenseManager.setLicenseKey(environment.AgGridLicenseKey);

// Register AG Grid modules (Community + Enterprise)
ModuleRegistry.registerModules([
    AllCommunityModule,
    ClientSideRowModelModule,
    RowGroupingModule,
    RowGroupingPanelModule,
    MenuModule,
    ExcelExportModule,
    ClipboardModule,
]);

// Configure AWS Amplify
Amplify.configure({
    Auth: {
        Cognito: {
            userPoolClientId: environment.cognito.userPoolClientId,
            userPoolId: environment.cognito.userPoolId,
        },
    },
    API: {
        Events: {
            endpoint: environment.events.endpoint,
            region: environment.events.region,
            defaultAuthMode: 'apiKey',
            apiKey: environment.events.apiKey,
        },
    },
});

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
